import { IPaymentMethodTab } from 'models/payments'
import CreditCardIcon from 'assets/icons/CreditCardIcon'
import {
  HISTORY_PAYMENT_STATUS,
  PAYMENT_METHODS,
  PLAN_PAYMENT_STATUS,
} from 'lib/enums/payments.enums'
import DatabaseIcon from 'assets/icons/DatabaseIcon'
import SendIcon from 'assets/icons/SendIcon'

export const planPaymentStatusLabelMap = {
  [PLAN_PAYMENT_STATUS.PAGADO]: 'Pagado',
  [PLAN_PAYMENT_STATUS.POR_PAGAR]: 'Por pagar',
  [PLAN_PAYMENT_STATUS.VENCIDO]: 'Vencido',
} as const

export const historyPaymentStatusLabelMap = {
  [HISTORY_PAYMENT_STATUS.GENERANDO_FACTURA]: 'Generando factura',
  [HISTORY_PAYMENT_STATUS.PAGADO]: 'Pagado',
} as const

export const planPaymentStatusClassNameMap = {
  [PLAN_PAYMENT_STATUS.PAGADO]: 'success',
  [PLAN_PAYMENT_STATUS.POR_PAGAR]: 'warning',
  [PLAN_PAYMENT_STATUS.VENCIDO]: 'error',
} as const

export const historyPaymentStatusClassNameMap = {
  [HISTORY_PAYMENT_STATUS.PAGADO]: 'success',
  [HISTORY_PAYMENT_STATUS.GENERANDO_FACTURA]: 'warning',
} as const

export const paymentMethodsLabelMap = {
  [PAYMENT_METHODS.TARJETA]: 'Tarjeta',
  [PAYMENT_METHODS.EFECTIVO]: 'Efectivo',
  [PAYMENT_METHODS.TRANSFERENCIA]: 'Transferencia',
} as const

export const paymentMethodTabs: Readonly<IPaymentMethodTab[]> = [
  {
    id: paymentMethodsLabelMap[PAYMENT_METHODS.TARJETA],
    icon: CreditCardIcon,
    label: paymentMethodsLabelMap[PAYMENT_METHODS.TARJETA],
    disabled: false,
    target: PAYMENT_METHODS.TARJETA,
  },
  {
    id: paymentMethodsLabelMap[PAYMENT_METHODS.EFECTIVO],
    icon: DatabaseIcon,
    label: paymentMethodsLabelMap[PAYMENT_METHODS.EFECTIVO],
    disabled: true,
    target: PAYMENT_METHODS.EFECTIVO,
  },
  {
    id: paymentMethodsLabelMap[PAYMENT_METHODS.TRANSFERENCIA],
    icon: SendIcon,
    label: paymentMethodsLabelMap[PAYMENT_METHODS.TRANSFERENCIA],
    disabled: true,
    target: PAYMENT_METHODS.TRANSFERENCIA,
  },
] as const
